import React from "react";

interface JsonLdProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Renders one or more JSON-LD blocks. Use inside SEO config arrays.
 * Examples: Organization, FAQPage, Product, Person, BreadcrumbList.
 */
export function JsonLd({ schema }: JsonLdProps) {
  const list = Array.isArray(schema) ? schema : [schema];
  return (
    <>
      {list.map((s, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(s) }}
        />
      ))}
    </>
  );
}

export default JsonLd;
